// Importar o inicializador de tema primeiro para garantir que o tema seja aplicado antes de qualquer renderização
import './utils/theme-initializer.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { ColorSchemeProvider } from '@/contexts/ThemeContext'
import { ContentProvider } from '@/contexts/ContentContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import './styles/brand-theme.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ColorSchemeProvider>
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </ColorSchemeProvider>
  </React.StrictMode>,
) 